document.addEventListener("DOMContentLoaded", function () {
  const $ = (id) => document.getElementById(id);

  const wrap = document.querySelector("[data-roi]");
  if (!wrap) return;

  const ids = [
    "roi_price","roi_cost","roi_cups","roi_peak",
    "roi_machine","roi_capacity","roi_hours",
    "roi_kw","roi_kwh","roi_low","roi_high"
  ];

  function num(id, fallback = 0) {
    const el = $(id);
    if (!el) return fallback;
    const v = parseFloat(el.value);
    return Number.isFinite(v) ? v : fallback;
  }

  function setText(id, v) {
    const el = $(id);
    if (el) el.textContent = v;
  }

  function buildShareURL(values) {
    const url = new URL(window.location.href);
    Object.entries(values).forEach(([k, v]) => url.searchParams.set(k, v));
    return url.toString();
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
    return Promise.resolve();
  }

  function calc() {
    const price    = num("roi_price");
    const cost     = num("roi_cost");
    const cupsDay  = num("roi_cups");
    const peakHour = num("roi_peak");
    const machine  = num("roi_machine");
    const capHour  = num("roi_capacity");
    const hoursDay = num("roi_hours", 8);

    const kw   = num("roi_kw", 0);
    const kwh  = num("roi_kwh", 0);
    const lowF  = num("roi_low", 0.8);
    const highF = num("roi_high", 1.1);

    const profitCup = Math.max(price - cost, 0);

    const elecDaily = Math.max(kw * hoursDay * kwh, 0);

    const dailyNet = Math.max(profitCup * cupsDay - elecDaily, 0);
    const monthlyNet = dailyNet * 30;

    const paybackDays = dailyNet > 0 ? machine / dailyNet : 0;
    const breakevenCups = profitCup > 0 ? machine / profitCup : 0;

    setText("r_profit", profitCup.toFixed(2));
    setText("r_daily", dailyNet.toFixed(2));
    setText("r_monthly", monthlyNet.toFixed(0));
    setText("r_payback", paybackDays.toFixed(1));
    setText("r_breakeven", breakevenCups.toFixed(0));

    const capMsgEl = $("r_capacity_msg");
    if (capMsgEl) {
      if (capHour <= 0 || peakHour <= 0) {
        capMsgEl.textContent = "Capacity check: add peak hour demand and machine capacity for a match test.";
        capMsgEl.className = "roi-capacity roi-capacity-neutral";
      } else if (peakHour <= capHour) {
        capMsgEl.textContent = `Capacity check: OK. Peak demand (${peakHour}/h) is within rated output (${capHour}/h).`;
        capMsgEl.className = "roi-capacity roi-capacity-ok";
      } else {
        const ratio = (peakHour / capHour).toFixed(1);
        capMsgEl.textContent =
          `Capacity check: Warning. Peak demand (${peakHour}/h) exceeds rated output (${capHour}/h). ` +
          `You may need a higher-capacity or dual-barrel model (~${ratio}×).`;
        capMsgEl.className = "roi-capacity roi-capacity-warn";
      }
    }

    setText("r_low_monthly", (monthlyNet * lowF).toFixed(0));
    setText("r_high_monthly", (monthlyNet * highF).toFixed(0));

    const values = {
      price: price.toFixed(2),
      cost: cost.toFixed(2),
      cups: Math.round(cupsDay),
      peak: Math.round(peakHour),
      machine: Math.round(machine),
      capacity: Math.round(capHour),
      hours: Math.round(hoursDay),
      kw: kw.toFixed(1),
      kwh: kwh.toFixed(2),
      low: lowF.toFixed(2),
      high: highF.toFixed(2)
    };

    const shareURL = buildShareURL(values);
    const embed = `<iframe src="${shareURL}&embed=1" width="600" height="780" frameborder="0" loading="lazy"></iframe>`;
    const embedTA = $("roi_embed_code");
    if (embedTA) embedTA.value = embed;

    const copyBtn = $("roi_copy");
    const shareBtn = $("roi_share");
    const embedCopyBtn = $("roi_embed_copy");

    if (copyBtn) copyBtn.onclick = () => {
      const txt =
        `Gross profit/cup: $${profitCup.toFixed(2)}; ` +
        `Daily net profit: $${dailyNet.toFixed(2)}; ` +
        `Monthly net profit: $${monthlyNet.toFixed(0)}; ` +
        `Payback: ${paybackDays.toFixed(1)} days; ` +
        `Break-even volume: ${breakevenCups.toFixed(0)} cups.`;
      copyText(txt);
    };

    if (shareBtn) shareBtn.onclick = () => copyText(shareURL);
    if (embedCopyBtn) embedCopyBtn.onclick = () => copyText(embed);

    $("roi_result").hidden = false;
    $("roi_result").scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function reset() {
    ids.forEach((id) => {
      const el = $(id);
      if (!el) return;
      if (el.type === "range") el.value = el.getAttribute("value") || el.defaultValue || "8";
      else el.value = el.getAttribute("value") || el.defaultValue || "";
    });
    const hours = $("roi_hours");
    if (hours) setText("roi_hours_val", hours.value);
    $("roi_result").hidden = true;

    const url = new URL(window.location.href);
    url.search = "";
    history.replaceState({}, "", url.toString());
  }

  function preloadFromParams() {
    const p = new URLSearchParams(window.location.search);
    const map = {
      price:"roi_price", cost:"roi_cost", cups:"roi_cups", peak:"roi_peak",
      machine:"roi_machine", capacity:"roi_capacity", hours:"roi_hours",
      kw:"roi_kw", kwh:"roi_kwh", low:"roi_low", high:"roi_high"
    };
    Object.entries(map).forEach(([k, id]) => {
      if (p.has(k) && $(id)) $(id).value = p.get(k);
    });

    const hours = $("roi_hours");
    if (hours) setText("roi_hours_val", hours.value);

    if (p.toString()) calc();
  }

  const hoursEl = $("roi_hours");
  if (hoursEl) {
    hoursEl.addEventListener("input", () => setText("roi_hours_val", hoursEl.value));
  }

  const calcBtn = $("roi_calc_btn");
  if (calcBtn) calcBtn.addEventListener("click", calc);

  const resetBtn = $("roi_reset_btn");
  if (resetBtn) resetBtn.addEventListener("click", (e) => {
    e.preventDefault();
    reset();
  });

  preloadFromParams();
});
